import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { ClipboardCheck, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { pendingApprovalsApi } from "@/lib/admin-api/pending-approvals";

// ---------------------------------------------------------------------------
// PendingApprovalsWidget
// Protects: Direction's visibility into maker-checker queue on the admin
// dashboard. Renders null when the queue is empty.
// ---------------------------------------------------------------------------

export function PendingApprovalsWidget() {
  const { t } = useTranslation("admin");
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "pending-approvals"],
    queryFn: () => pendingApprovalsApi.list(),
    refetchInterval: 30_000,
  });

  const pendingCount =
    data?.items.filter((a) => a.status === "pending").length ?? 0;

  if (isLoading) {
    return (
      <div
        className="animate-pulse rounded-lg border border-stone-200 p-4"
        aria-hidden="true"
      >
        <div className="h-4 w-32 rounded bg-stone-200" />
        <div className="mt-2 h-8 w-12 rounded bg-stone-200" />
      </div>
    );
  }

  if (pendingCount === 0) return null;

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
      <h3 className="flex items-center gap-2 text-sm font-medium text-amber-800">
        <ClipboardCheck className="h-4 w-4" aria-hidden="true" />
        {t("products.approvals.title", "Approbations en attente")}
      </h3>
      <p className="mt-1 text-2xl font-bold tabular-nums text-amber-900">
        {pendingCount}
      </p>
      <Link
        to="/admin/produits/approbations"
        className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-amber-700 hover:text-amber-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
      >
        {t("products.approvals.view_all", "Voir les approbations")}
        <ArrowRight className="h-3 w-3" aria-hidden="true" />
      </Link>
    </div>
  );
}
